import { OneOrManySchema } from 'notable-common';
import { z } from 'zod';
import { FlowApiPageLimitSchema, FlowApiPageOffsetSchema } from '../pagination/pageLimit.js';
export var HumanTaskCategoryStatus;
(function (HumanTaskCategoryStatus) {
    HumanTaskCategoryStatus["Active"] = "Active";
    HumanTaskCategoryStatus["SoftDeleted"] = "SoftDeleted";
})(HumanTaskCategoryStatus || (HumanTaskCategoryStatus = {}));
export const BaseHumanTaskCategorySchema = z.object({
    name: z.string().min(1),
    description: z.string(),
    organizationId: z.uuid(),
    state: z.enum(HumanTaskCategoryStatus),
});
export const HumanTaskCategorySchema = BaseHumanTaskCategorySchema.extend({
    id: z.uuid(),
    created: z.iso.datetime(),
    updated: z.iso.datetime(),
});
export const HumanTaskCategoryQueryParamsSchema = z.object({
    q: z.string().optional(),
    id: OneOrManySchema(z.uuid()).optional(),
    organizationId: OneOrManySchema(z.uuid()).optional(),
    name: z.string().optional(),
    limit: FlowApiPageLimitSchema.describe('How many categories to return.').optional(),
    offset: FlowApiPageOffsetSchema.describe('How many matches to skip, for paging.').optional(),
    state: z.enum(HumanTaskCategoryStatus).optional(),
});
export const BaseHumanTaskCategoryUserSchema = z.object({
    categoryId: z.uuid(),
    userId: z.uuid(),
});
export const HumanTaskCategoryUserSchema = BaseHumanTaskCategoryUserSchema.extend({
    id: z.uuid(),
    created: z.iso.datetime(),
});
/**
 * Path parameters the endpoints addressing one category accept, including the ones addressing its
 * users. Named for what it carries rather than for any one of them.
 */
export const HumanTaskCategoryIdParamsSchema = z.object({
    categoryId: z.uuid().describe('The human task category.'),
});
export const HumanTaskCategoryUserQueryParamsSchema = z.object({
    limit: FlowApiPageLimitSchema.describe('How many category users to return.').optional(),
    offset: FlowApiPageOffsetSchema.describe('How many matches to skip, for paging.').optional(),
});
//# sourceMappingURL=category.js.map